import { useEffect } from "react"
import * as Sentry from "@sentry/react"
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router"
import { beforeSend } from "@f2e/shared/browser/sentry"

const sentryDsn = import.meta.env.VITE_SENTRY_WEB_DSN
const enableSentryInDev = import.meta.env.VITE_SENTRY_ENABLE_IN_DEV === "true"
export const sentryEnabled =
  Boolean(sentryDsn) && (import.meta.env.PROD || enableSentryInDev)

// The data-router wrapper must run after this integration has initialized.
if (sentryEnabled) {
  Sentry.init({
    dsn: sentryDsn,
    release: import.meta.env.VITE_RELEASE,
    environment: import.meta.env.VITE_SENTRY_ENV || import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: Number(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0.2"
    ),
    beforeSend,
  })
}
